<template>
  <div class="container-fluid bmo-form">
    <div class="card-header py-3">
      <h6 class="m-0 font-weight-bold text-primary">Create Series</h6>
    </div>
    <div class="card-body text-align-left">
      <Form type="Create" @submit="handleFormSubmit" @message="handleFormMessage" />
    </div>
    <!-- close card body -->
    <b-modal ref="modal" :title="modal.title" size="xl" ok-only>
      <p style="white-space: pre">{{ modal.content }}</p>
    </b-modal>
  </div>
  <!-- close container-fluid -->
</template>

<script>
import Form from '@/components/Forms/SeriesForm.vue';
import router from '@/router';
import { BModal } from "bootstrap-vue";

export default {
  name: 'CreateSerie',
  components: {
    Form,
    BModal,
  },
  data() {
    return {
      modal: {
        title: "Error",
        content: "",
      }
    }
  },
  methods: {
    handleFormSubmit() {
      router.push('/series');
    },
    handleFormMessage(message) {
      this.modal = Object.assign(
        this.modal,
        {
          content: message,
        }
      );
      this.$refs.modal.show();
    }
  }
};
</script>